import React, { useState, useEffect } from "react";
import {
  Dialog,
  Classes,
  FormGroup,
  InputGroup,
  TextArea,
  Button,
  Drawer
} from "@blueprintjs/core";
import Flexbox from "flexbox-react";
import ScrollableDropdown from "../shared/ScrollableDropdown";
import { FilledButton, TextButton } from "../buttons-20250224T111359Z-001/buttons";

const StepDrawer = ({ isOpen, onClose, step, onSave, jobProfiles }) => {
  const [form, setForm] = useState({
    id: null,
    name: "",
    description: "",
    job_profile_id: null
  });
  const [selectedJobProfile, setSelectedJobProfile] = useState(null);
 console.log("step", step);
  useEffect(() => {
    if (step) {
      setForm({
        id: step.id || null,
        name: step.name || "",
        description: step.description || "",
        job_profile_id: step.job_profile_id || null
      });
    }
  }, [step]);

  const handleSave = () => {
    if (!form.name.trim()) return;

    onSave(form);
  };
  useEffect(() => {
    if (!isOpen) {
      setForm({ id: null, name: "", description: "" });
    }
  }, [isOpen]);

  return (
    <Drawer
      portalContainer={document.body}
      size={"50%"}
      isOpen={isOpen}
      onClose={onClose}
      title={form.id ? "Edit Onboarding Step" : "Add Onboarding Step"}
    >
      <Flexbox
        flexDirection="column"
        flexGrow={1}
        padding="15px"
        style={{ height: "100%" }}
      >


        <FormGroup label="Step Name" labelFor="step-name">
          <InputGroup
            id="step-name"
            placeholder="Add a step title"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />
        </FormGroup>

        <FormGroup label="Description" labelFor="step-desc">
          <TextArea
            id="step-desc"
            fill
            growVertically
            placeholder="Add more details"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
          />
        </FormGroup>
        <div style={{ width: "250px" }}>
          <ScrollableDropdown
            width={250}
            label={
              jobProfiles.find(p => p.id === form.job_profile_id)?.name
              || "Select Job Profile"}
            items={jobProfiles}
            getKey={p => p.id}
            getLabel={p => p.name}
            enableSearch
            onSelect={profile =>
              setForm({ ...form, job_profile_id: profile.id })
            }
          />
        </div>
        <div style={{ marginTop: "20px" }}>
          <FilledButton text={form.id ? "Update" : "Add"} onClick={handleSave} />
          <TextButton text="Cancel" onClick={onClose} />
        </div>
      </Flexbox>


    </Drawer>
  );
};

export default StepDrawer;



















